import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["replyToggle", "replyForm"]
  
  connect() {
    console.log('💬 Comment Actions Controller connected for comment', this.element.dataset.commentId)
  }

  toggleReply() {
    console.log('🔄 Toggling reply form for comment', this.element.dataset.commentId)
    
    if (this.hasReplyFormTarget) {
      if (this.replyFormTarget.classList.contains('hidden')) {
        this.showReplyForm()
      } else {
        this.hideReplyForm()
      }
    }
  }

  showReplyForm() {
    console.log('📝 Showing reply form')
    
    if (this.hasReplyFormTarget) {
      this.replyFormTarget.classList.remove('hidden')
      
      // Focus on the textarea
      const textarea = this.replyFormTarget.querySelector('textarea')
      if (textarea) {
        setTimeout(() => textarea.focus(), 100)
      }
      
      // Update button text
      if (this.hasReplyToggleTarget) {
        this.replyToggleTarget.innerHTML = `
          <i class="fas fa-times mr-1"></i>
          Cancel
        `
      }
    }
  }

  hideReplyForm() {
    console.log('🙈 Hiding reply form')
    
    if (this.hasReplyFormTarget) {
      this.replyFormTarget.classList.add('hidden')
      
      // Clear the textarea
      const textarea = this.replyFormTarget.querySelector('textarea')
      if (textarea) {
        textarea.value = ''
        textarea.style.height = 'auto' // Reset auto-resize
      }
      
      // Reset button text
      if (this.hasReplyToggleTarget) {
        this.replyToggleTarget.innerHTML = `
          <i class="fas fa-reply mr-1 group-hover:scale-110 transition-transform"></i>
          Reply
        `
      }
    }
  }

  cancelReply() {
    console.log('❌ Cancelling reply')
    this.hideReplyForm()
  }

  replyAdded(event) {
    console.log('✅ Reply added successfully')
    
    // Hide the reply form
    this.hideReplyForm()
    
    // Show success feedback
    this.showFeedback('Reply added successfully!', 'success')
    
    // Scroll the new reply into view
    setTimeout(() => {
      const newReply = this.element.querySelector('.comment-item:last-child')
      if (newReply) {
        newReply.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    }, 100)
  }

  showFeedback(message, type) {
    // Create temporary feedback element
    const feedback = document.createElement('div')
    feedback.className = `fixed top-4 right-4 z-50 px-3 py-2 rounded-lg text-xs font-medium transition-all duration-300 ${
      type === 'success' 
        ? 'bg-green-100 text-green-800 border border-green-200' 
        : 'bg-red-100 text-red-800 border border-red-200'
    }`
    feedback.textContent = message
    feedback.style.opacity = '0'
    feedback.style.transform = 'translateY(-10px)'
    
    document.body.appendChild(feedback)
    
    // Animate in
    requestAnimationFrame(() => {
      feedback.style.opacity = '1'
      feedback.style.transform = 'translateY(0)'
    })
    
    // Remove after delay
    setTimeout(() => {
      feedback.style.opacity = '0'
      feedback.style.transform = 'translateY(-10px)'
      setTimeout(() => {
        if (document.body.contains(feedback)) {
          document.body.removeChild(feedback)
        }
      }, 300)
    }, 2500)
  }
}